import React from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Hero from '../Hero'
import HeroHighlights from '../HeroHighlights'
import About from '../About'
import Services from '../Services'
import DevelopmentProcess from '../DevelopmentProcess'
import VisionVoteAdvantage from '../VisionVoteAdvantage'
import TechnologyConsulting from '../TechnologyConsulting'
import CTASection from '../CTASection'



const Home = () => {
  return (
    <>
      <Header/>

           <Hero/>
           <HeroHighlights/>
           <About/>
           <Services/>
           <DevelopmentProcess/>
           <VisionVoteAdvantage/>
           <TechnologyConsulting/>
           <CTASection/>
            
      <Footer/>
    </>
  )
}

export default Home
